module.exports = __webpack_public_path__ + "img/03.2a24e861.jpg";